import React, { useEffect, useState } from "react";

import FeaturedSettings from "../FeaturedSettings";

import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";
import {
  getPerson,
  getPersonData,
  getPickupEntries,
  getPickupPersonData,
  getPickupPersonTitle,
  setFeaturedPersons,
} from "../../../../redux/reducers/person";

import { RequestState } from "../../../../utils/RequestState";

const FeaturedProfileSettingsContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const auth_token = useAppSelector(getAuthToken);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  // Pickup
  const featuredProfiles = useAppSelector(getPickupPersonData);
  const featuredProfilesTitle = useAppSelector(getPickupPersonTitle);
  const [featuredProfilesList, setFeaturedProfilesList] = useState<
    Array<{ id: string; name: string; status: string }>
  >([]);
  const [profilesTitle, setProfilesTitle] = useState<string>("");

  useEffect(() => {
    const promise = dispatch(getPickupEntries());

    promise.finally(() => {
      setIsLoading(false);
    });

    return () => {
      promise.abort();
    };
  }, []);

  useEffect(() => {
    const fProfiles: Array<{ id: string; name: string; status: string }> = [];

    for (const fProfile of featuredProfiles) {
      fProfiles.push({
        id: fProfile.id,
        name: fProfile.name,
        status: fProfile.status,
      });
    }

    setFeaturedProfilesList([...fProfiles]);
  }, [featuredProfiles]);

  useEffect(() => {
    setProfilesTitle(featuredProfilesTitle ? featuredProfilesTitle : "");
  }, [featuredProfilesTitle]);

  // Profile
  const profiles = useAppSelector(getPersonData);
  const [profileNameList, setProfileNameList] = useState<Array<string>>([]);

  useEffect(() => {
    const promise = dispatch(getPerson({ per: -1 }));

    return () => {
      promise.abort();
    };
  }, []);

  useEffect(() => {
    const pNames: Array<string> = [];

    for (const profile of profiles) {
      pNames.push(profile.name);
    }

    setProfileNameList([...pNames]);
  }, [profiles]);

  // Handler
  const handleChange = (index: number, value: string) => {
    const profile = profiles.find(({ name }) => name == value);
    if (profile) {
      if (featuredProfilesList.find(({ id }) => id == profile.id)) {
        //TODO: Show error
      }

      const newProfile = {
        id: profile.id,
        name: profile.name,
        status: profile.status,
      };

      const fProfiles = featuredProfilesList;
      fProfiles[index] = newProfile;
      setFeaturedProfilesList([...fProfiles]);
      setRequestState(RequestState.Pending);
    } else {
      const newProfile = { id: "", name: value, status: "" };

      const fProfiles = featuredProfilesList;
      fProfiles[index] = newProfile;
      setFeaturedProfilesList([...fProfiles]);
      setRequestState(RequestState.Pending);
    }
    return false;
  };

  const handleTitle = (value: string) => {
    setProfilesTitle(value);
  };

  const addItem = () => {
    const fProfiles = featuredProfilesList;

    fProfiles.push({ id: "", name: "", status: "" });
    setFeaturedProfilesList([...fProfiles]);
  };

  const removeItem = (index: number) => {
    const fProfiles = featuredProfilesList;

    fProfiles.splice(index, 1);
    setFeaturedProfilesList([...fProfiles]);
  };

  const handleSubmit = () => {
    if (auth_token) {
      setRequestState(RequestState.Doing);

      const ids: Array<string> = [];
      const fProfiles = featuredProfilesList;

      for (const fProfile of fProfiles) {
        ids.push(fProfile.id);
      }

      dispatch(
        setFeaturedPersons({
          auth_token: auth_token,
          ids: ids,
          title: profilesTitle,
        })
      ).finally(() => setRequestState(RequestState.Success));
    }
  };

  useEffect(() => {
    setRequestState(RequestState.Waiting);
  }, [featuredProfilesList, profilesTitle]);

  return (
    <FeaturedSettings
      target="プロフィール"
      name="person"
      id="Persons"
      isLoading={isLoading}
      options={profileNameList}
      selectedItems={featuredProfilesList}
      featuredTitle={profilesTitle}
      requestState={requestState}
      addItem={addItem}
      removeItem={removeItem}
      handleChange={handleChange}
      handleTitle={handleTitle}
      handleSubmit={handleSubmit}
    />
  );
};

export default FeaturedProfileSettingsContainer;
